<template>
  <v-card class="pa-2 vehicle-list-item">
    <v-row>
      <v-col sm="2">
        <span class="light-title">{{$t('fleet.licence_plate')}}</span><br>
        {{vehicle.licence_plate}}
      </v-col>
      <v-col sm="2">
        <span class="light-title">{{$t('fleet.name')}}</span><br>
        {{vehicle.name}}
      </v-col>
      <v-col sm="2">
        <span class="light-title">{{$t('fleet.volume')}}</span><br>
        {{vehicleVolume | roundValue(1)}} m&sup3;
      </v-col>
      <v-col sm="2">
        <span class="light-title">{{$t('fleet.max_weight')}}</span><br>
        {{vehicle.properties.vehicle_max_weight | roundValue(1)}} kg
      </v-col>
      <v-col sm="3">
        <span class="light-title">{{$t('fleet.allowed_countries')}}</span><br>
        <v-chip
          label
          small
          color="kazan"
          text-color="white"
          v-for="(allowed_country, i) in vehicle.allowed_countries"
          :key="i"
        >
          <v-icon
            left
            small
          >label_important</v-icon>
          {{allowed_country}}
        </v-chip>
      </v-col>
      <v-col sm="1">
        <v-btn
          text
          icon
          color="kazan"
          @click="gotoDetail(vehicle.id) "
        >
          <v-icon>launch</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import router from '@/router'

export default {
  name: 'VehicleListItem',
  components: {},
  props: {
    vehicle: Object
  },
  data () {
    return {}
  },
  computed: {
    vehicleVolume () {
      const dims = this.vehicle.properties.vehicle_dimensions
      return (dims.height * dims.length * dims.width) / 1000000 // in cubic meters
    }
  },
  methods: {
    gotoDetail (vehicleID) {
      router.push({
        name: 'VehicleDetail',
        params: { companyID: this.companyID, vehicleID: vehicleID }
      })
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>
  .vehicle-list-item {
    border-top: 1px solid lightgray !important;
    border-radius: 0;
  }
  .light-title {
    font-size: 12px;
    color: gray;
  }
</style>
